export default "__VITE_ASSET__DKkHacxN__"